import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  InMemoryCache,
  NormalizedCacheObject,
  // ServerError,
} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
import { CARESTUDIO_APOLLO_CONTEXT, CARESTUDIO_PROXY_TO_CRM_CONTEXT, CARE_STUDIO_MIDDLEWARE_URL, CARE_STUDIO_PROXY_TO_CRM_URL, CLOUD_TELEPHONY_APOLLO_CONTEXT, CLOUD_TELEPHONY_GRAPHQL_URL, CRM_GRAPHQL_URL, FEED_SERVICE_APOLLO_CONTEXT, FEED_SERVICE_URL, FHIR_APOLLO_CONTEXT, FHIR_BASE_URL, HASURA_SECRET } from '../../constants/Configs';

let client: ApolloClient<NormalizedCacheObject>;

export const careStudioToCRMProxy = createHttpLink({
  uri: CARE_STUDIO_PROXY_TO_CRM_URL,
});

export const cloudTelephony = createHttpLink({
  uri: CLOUD_TELEPHONY_GRAPHQL_URL,
});

export const fhir = createHttpLink({
  uri: FHIR_BASE_URL,
});

const authLink = setContext(async (_, {headers}) => {
 // const userDataString = await LocalStorage.getItem('user');
  //const accountJsonString = await LocalStorage.getItem('account');

  //const userData = JSON.parse(userDataString);
  //const accountData = JSON.parse(accountJsonString);

  const foldAccessToken = await localStorage.getItem('foldAccessToken') ?? '';
  //const client = userData?.client || '';
  //const responseAccessToken = userData?.accessToken || '';
  //const accountId = userData?.data.account_id || accountData?.accountId || '';
  //const fold_access_token = userData?.fold_access_token || '';
  const headersObj = {
    fold_access_token: foldAccessToken,
   // account: accountId,
    client: client,
    //fold_access_token: fold_access_token,
    'x-hasura-role': 'user',
    'x-hasura-user-name': 'user',
    //'access-token': responseAccessToken,
    'x-hasura-admin-secret': HASURA_SECRET,
    //'user-uuid': userData?.data.uuid || '',
    // 'account-uuid':
    //   userData?.data.accounts.length > 0
    //     ? userData?.data.accounts[0].uuid || ''
    //     : '',
    ...headers,
  };

  // if (accountId) {
  //   headersObj['x-hasura-account-id'] = accountId;
  // }
  if (headersObj?.['account-uuid']) {
    headersObj['x-hasura-account-uuid'] = headersObj['account-uuid'];
  }

  return {
    headers: headersObj,
  };
});
const crmHttpLink = createHttpLink({
  uri: CRM_GRAPHQL_URL,
});

const careStudioHttpLink = createHttpLink({
  uri: CARE_STUDIO_MIDDLEWARE_URL,
});

const feedServiceHttpLink = createHttpLink({
  uri: FEED_SERVICE_URL,
});

const feedOrCloudTelephonyContextSwitchLink = ApolloLink.split(
  (operation) => {
    return operation.getContext().service === CLOUD_TELEPHONY_APOLLO_CONTEXT;
  },
  cloudTelephony,
  feedServiceHttpLink
);

const careStudioAndProxyCRMContextSwitchLink = ApolloLink.split(
  (operation) => {
    return operation.getContext().service === CARESTUDIO_PROXY_TO_CRM_CONTEXT;
  },
  careStudioToCRMProxy,
  careStudioHttpLink
);

const feedOrCareStudioContextSwitchLink = ApolloLink.split(
  (operation) => {
    return (
      operation.getContext().service === CARESTUDIO_APOLLO_CONTEXT ||
      operation.getContext().service === CARESTUDIO_PROXY_TO_CRM_CONTEXT
    );
  },
  careStudioAndProxyCRMContextSwitchLink,
  feedOrCloudTelephonyContextSwitchLink
);

const fhirOrCRMContextSwitchLink = ApolloLink.split(
  (operation) => {
    return operation.getContext().service === FHIR_APOLLO_CONTEXT;
  },
  fhir,
  crmHttpLink
);

const contextSwitchLink = ApolloLink.split(
  (operation) => {
    return (
      operation.getContext().service === CARESTUDIO_APOLLO_CONTEXT ||
      operation.getContext().service === CARESTUDIO_PROXY_TO_CRM_CONTEXT ||
      operation.getContext().service === FEED_SERVICE_APOLLO_CONTEXT ||
      operation.getContext().service === CLOUD_TELEPHONY_APOLLO_CONTEXT
    );
  },
  feedOrCareStudioContextSwitchLink,
  fhirOrCRMContextSwitchLink
);

export function getClient(errorLink: any) {
  if (!client) {
    client = new ApolloClient({
      link: authLink.concat(errorLink).concat(contextSwitchLink),
      cache: new InMemoryCache({
        addTypename: false,
      }),
      headers: {
        'Content-Type': 'application/json',
        // api_access_token: 'fd1ZKmnmypszABmVc5sf4VTj',
        // account: '2',
        // 'x-hasura-admin-secret': 'PisC]MKN2U',
        'Access-Control-Allow-Credentials': 'true',
      },
    });
  }
  return client;
}

export default {getClient};
